// Standalone strain-reviews — network layer.
// Both endpoints are public (no auth) and CORS-wide-open in main.py.

import { API_URL } from './config.js';

export async function fetchStrainReviews(strainName) {
    // business_id is REQUIRED in the path so the origin-allowlist middleware can
    // gate this route per-business (anti-scrape). Without it we fail closed.
    const businessId = (typeof window !== 'undefined'
                        && window.VB_STRAIN_REVIEWS_CONFIG
                        && window.VB_STRAIN_REVIEWS_CONFIG.BUSINESS_ID) || null;
    if (!businessId) return null;
    try {
        const res = await fetch(
            `${API_URL}/admin/public/strain-reviews/${encodeURIComponent(businessId)}/${encodeURIComponent(strainName)}`,
            { mode: 'cors', credentials: 'omit' }
        );
        if (!res.ok) return null;
        const body = await res.json();
        return body && body.success ? body.data : null;
    } catch (e) {
        return null;
    }
}

// Bulk source-count lookup for the dynamic injected-button label
// ("Check what N sources say about this strain →"). business_id is REQUIRED
// in the path so the origin-allowlist middleware gates the route per-business.
// Returns the body.data map { "<original_name>": <int count>, ... } or {} on
// any error / missing config (caller keeps the neutral fallback label).
export async function fetchSourceCounts(businessId, names) {
    if (!businessId || !Array.isArray(names) || !names.length) return {};
    try {
        const q = encodeURIComponent(names.join(','));
        const res = await fetch(
            `${API_URL}/admin/public/strain-source-counts/${encodeURIComponent(businessId)}?names=${q}`,
            { mode: 'cors', credentials: 'omit' }
        );
        if (!res.ok) return {};
        const body = await res.json();
        return (body && body.success && body.data) ? body.data : {};
    } catch (e) {
        return {};
    }
}

export async function fetchStrainReviewsConfig(businessId) {
    try {
        const res = await fetch(
            `${API_URL}/admin/public/strain-reviews-config/${encodeURIComponent(businessId)}`,
            { mode: 'cors', credentials: 'omit' }
        );
        if (!res.ok) return null;
        const body = await res.json();
        return body && body.success ? body.data : null;
    } catch (e) {
        return null;
    }
}

export async function postStrainReviewView(strainName) {
    const businessId = (typeof window !== 'undefined'
                        && window.VB_STRAIN_REVIEWS_CONFIG
                        && window.VB_STRAIN_REVIEWS_CONFIG.BUSINESS_ID) || null;
    try {
        await fetch(`${API_URL}/strain-review-view`, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                strain_name: strainName,
                origin: (typeof window !== 'undefined' && window.location && window.location.origin) || null,
                business_id: businessId,
            }),
        });
    } catch (e) { /* silent */ }
}
